var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2899_75031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5C11 5.27614 11.2239 5.5 11.5 5.5H16.5C17.3284 5.5 18 6.17157 18 7V15C18 15.8284 17.3284 16.5 16.5 16.5H2.5C1.67157 16.5 1 15.8284 1 15V4C1 3.17157 1.67157 2.5 2.5 2.5H9.5C10.3284 2.5 11 3.17157 11 4V5Z",
    fill: "#F2F5FF",
    stroke: "#7B8CC8",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2899_75031"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon_folder.8fefe7f21bed5fa93395b2838452c7ea.svg";
export { ForwardRef as ReactComponent };